import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { useService } from "../../context/ServiceContext";
import CertificateThirdPartyProductSelection from "../../components/Certificates/CertificateThirdPartyProductSelection";

function CertificatesThirdPartyEdit({ history, match }) {
  const [existingCertificate, setExistingCertificate] = useState(null);
  const { keyCompany, series, language, documentClass, documentReference, idTipoDocumental, idNotaCert } = match.params;
  const { certificateExistingThirdPartyProvider } = useService();

  useEffect(() => {
    async function getData() {
      try {
        const certificateData = await certificateExistingThirdPartyProvider.get({
          keyCompany,
          series,
          language,
          documentClass,
          documentReference,
          idTipoDocumental,
          idNotaCert,
        });
        setExistingCertificate(certificateData);
      } catch (error) {
      } finally {
      }
    }
    getData();
  }, []);

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                {existingCertificate && (
                  <>
                    <CertificateThirdPartyProductSelection history={history} existingCertificate={existingCertificate}></CertificateThirdPartyProductSelection>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CertificatesThirdPartyEdit;
